/* This example requires Tailwind CSS v2.0+ */
import { Primary } from "../buttons/Primary";
import { Fifth } from "../buttons/Fifth";

const features = [
  {
    description:
      "Lo pides desde nuestra web en tu celular o computador y lo recibes en menos de 1 día hábil a tu cuenta.",
  },
  {
    description: "Sin filas, sin papeles, sin codeudor.",
  },
  {
    description: "Tasa de interés fija de 1,88% M.V. o 25% E.A.",
  },
  {
    description:
      "Plazo mínimo 60 días y plazo máximo 90 días aplicando a la extensión que puedes usar si lo requieres.",
  },
];

export function Feature() {
  return (
    <div className="overflow-hidden bg-purpleLight font-walsheim text-tdark">
      <div className="max-w-7xl mx-auto py-20 px-6 lg:px-8 pt-28">
        <div className="lg:flex">
          <div className="relative block">
            <div className="lg:hidden">
              <img
                className="w-110 h-auto"
                src="/png/feature.png"
                alt="Crear-cuenta"
              />
            </div>
          </div>
          <div className="lg:w-1/2 lg:pr-20">
            <div className="">
              <h2 className="pt-8 lg:pt-0 text-4xl font-bold tracking-tight sm:text-5xl lg:pr-20">
                El crédito digital que te ahorra tiempo en filas
              </h2>
            </div>
            <dl className="my-10 space-y-10">
              <ul className="space-y-4 marker:text-tdark list-disc text-lg">
                {features.map((feature, idx) => (
                  <li key={idx} className="ml-4 mt-2 text-lg">
                    {feature.description}
                  </li>
                ))}
              </ul>
              <div className="pt-4">
                <div className="lg:flex">
                  <div className="block lg:w-1/2 py-2">
                    <a
                      href="/registrarse"
                      className="w-52 pb-10 md:mx-0 mx-auto"
                    >
                      <Primary text="Aplicar ahora" />
                    </a>
                  </div>
                  <div className="pl-2 block lg:w-1/2 py-2">
                    <a href="/tarifas" className="w-52 pb-10 md:mx-0 mx-auto">
                      <Fifth text="Tasas y tarifas" />
                    </a>
                  </div>
                </div>
              </div>
            </dl>
          </div>
          <div className="relative block lg:w-1/2">
            <div className="hidden md:block lg:absolute lg:w-120 h-auto lg:top-1/2 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2">
              <img
                className="w-110 h-auto"
                src="/png/feature.png"
                alt="Crear-cuenta"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
